import React from 'react'

const links = ["home", "about", "timeline", "projects", "socials"]

function Links(props) {
  const onLinkClick = (link) => {
    props.onClick && props.onClick()
    window.scroll({top: document.getElementById(link).offsetTop, behavior: "smooth"})
  }
  return (
    <>
      {
        links.map((link, i) => 
          <div className="navbar-links-link" key={i} onClick={() => onLinkClick(link)}><p>{link}</p></div>
        )
      }
    </>
  )
}

export default Links
